import React from "react";

/*
TODO:
The value place will be dynamic and will be picked from message
we will use same for A15 submit
CCS is yet to be done
*/
function MessageA21(props) {

  const buttonStyle = () => {
    return {
            
    }
  }

  const A1Action = () => {
      
    // 
  }

  const buttonValue = (props.entries && props.entries.text) || "";
  return (
    <div className={"s360-message-code-a1-container"}>
      <input className="s360-message-code-a1-button" type='button' value={buttonValue} onClick={A1Action} style={buttonStyle()} disabled={props.disabled}/>
    </div>
  )
}

export default MessageA21;